module.exports = require('buffer').Buffer;



//////////////////
// WEBPACK FOOTER
// ./build/temp/library/webpack/BFSBuffer.js
// module id = 1
// module chunks = 0